import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./TimePickerInput.module.styl";

function TimePickerInput({ value, onChange, name, isInvalid, disabled, className, ...props }) {
    return (
        <input
            className={cx(styles.input, isInvalid && styles.invalid, className)}
            type={"time"}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            {...props}
        />
    );
}

TimePickerInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    isInvalid: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

export default TimePickerInput;
